import { BROKER_LOGO } from "@/config/logos";

export const brokersList = [
  {
    id: "4",
    name: "Alpaca",
    note: <p></p>,
    logo: BROKER_LOGO["ALPACA"].DARK.textLogo,
    icon: BROKER_LOGO["ALPACA"].DARK.logo,
    defaultPassphrase: "s",
    type: "virtual",
    footerLink: "https://app.alpaca.markets/signup",
  },
  {
    id: "1",
    name: "Match Trade ",
    note: <p></p>,
    defaultApiSecret: "0",
    logo: BROKER_LOGO["MATCHTRADE"].DARK.textLogo,
    icon: BROKER_LOGO["MATCHTRADE"].DARK.logo,

    type: "virtual",
    footerLink: "https://match-trader.com/",
  },
  {
    id: "2",
    name: "Ctrader",
    note: <p></p>,
    disabled: false,
    logo: BROKER_LOGO["CTRADER"].DARK.textLogo,
    icon: BROKER_LOGO["CTRADER"].DARK.logo,

    defaultPassphrase: "live",
    type: "live",
    footerLink: "https://ctrader.com/download",
  },
  {
    id: "13",
    name: "Lightspeed",
    note: <p></p>,
    disabled: false,
    defaultApiKey: "%20",
    defaultPassphrase: "%20",
    defaultApiSecret: "%20",
    logo: BROKER_LOGO["LIGHTSPEED"].DARK.textLogo,
    icon: BROKER_LOGO["LIGHTSPEED"].DARK.logo,
    type: "virtual",
    footerLink: "https://lightspeed.com/trading/api-trading/level2",
  },
  {
    id: "11",
    name: "Leverate",
    disabled: false,
    note: <p>{""}</p>,
    defaultPassphrase: "%20",
    logo: BROKER_LOGO["LEVERATE"].DARK.textLogo,
    icon: BROKER_LOGO["LEVERATE"].DARK.logo,
    type: "live",
  },
  {
    id: "5",
    name: "Trade Zero",
    disabled: true,
    defaultApiKey: "%20",
    defaultPassphrase: "%20",
    defaultApiSecret: "%20",
    note: <p>{"Coming Soon"}</p>,
    logo: BROKER_LOGO["TRADEZERO"].DARK.textLogo,
    icon: BROKER_LOGO["TRADEZERO"].DARK.logo,
    type: "virtual",
  },
  {
    id: "20",
    name: "Webbulls",
    disabled: true,
    defaultApiKey: "%20",
    defaultPassphrase: "%20",
    defaultApiSecret: "%20",
    note: <p>{"Coming Soon"}</p>,
    logo: BROKER_LOGO["WEBBULLS"].DARK.textLogo,
    icon: BROKER_LOGO["WEBBULLS"].DARK.logo,
    type: "live",
  },
  {
    id: "18",
    name: "Trade Station",
    disabled: true,
    defaultApiKey: "%20",
    defaultPassphrase: "%20",
    defaultApiSecret: "%20",
    note: <p>{"Coming Soon"}</p>,
    logo: BROKER_LOGO["TRADESTATION"].DARK.textLogo,
    icon: BROKER_LOGO["TRADESTATION"].DARK.logo,
    type: "virtual",
  },
  {
    id: "19",
    name: "Public",
    disabled: true,
    defaultApiKey: "%20",
    defaultPassphrase: "%20",
    defaultApiSecret: "%20",
    note: <p>{"Coming Soon"}</p>,
    logo: BROKER_LOGO["PUBLIC"].DARK.textLogo,
    icon: BROKER_LOGO["PUBLIC"].DARK.logo,
    type: "live",
  },
];
